import React, { useState } from 'react'
import './contact.css'
import data from '../FakeData'
import mainData from '../FetchDataLinks';
import validator from 'validator';
import UseFetchPost from '../UseFetchPost';
import SeoHelmet from '../SEOHelmet/SeoHelmet';

function Contact() {

    let justToTest = 0;
    const timing = setTimeout(() => {
        if (!document.getElementById('contact').classList.contains('active')) {
            document.getElementById("contact").className += 'active';
        }
    }, 100);


    const [value, setValue] = useState('');
    let emailID = '';
    let name = '';
    let phone = '';
    let message = '';
    let subject = '';

    function OnSubmitURI() {
        if (validator.isEmail(emailID)) {
            let mainmsg = message.replace(/[\r\n]+/gm, "")
            UseFetchPost(mainData.contact, `{"email": "${emailID}","name": "${name}","message":"${mainmsg}","phone":"${phone}","subject":"${subject}"}`)
            setValue('Thank You Contacting me. We hope to Reach out to you as soon as Possible')
            document.getElementById('w3lName').style.display = 'none'
            document.getElementById('w3lSubject').style.display = 'none'
            document.getElementById('w3lSender').style.display = 'none'
            document.getElementById('w3lPhone').style.display = 'none'
            document.getElementById('w3lMessage').style.display = 'none'
            document.getElementById('submitbtn').style.display = 'none'
        }
    }



    if (justToTest === 5) {
        clearTimeout(timing)
    }


    return (
        <div className="w3l-contact-10 py-5" id="contact">
            <SeoHelmet pageName='Contact' />
            <div className="form-41-mian pt-lg-4 pt-md-3 pb-md-4">
                <div className="container">
                    <div className="heading">
                        <h1 className="category-title mb-3">Contact us </h1>
                        <p className="mb-md-5 mb-4">If you have a question regarding My services, feel free
          to contact me using the form below.</p>
                    </div>
                    <div className="row">
                        <div className="col-lg-8 form-inner-cont">
                            <div className='signin-form'>
                                <h3>{value}</h3>
                                <div className="form-grids">
                                    <div className="form-input">
                                        <input type="text" name="name" id="w3lName" onChange={(e) => { name = e.target.value }} placeholder="Enter your name *" required />
                                    </div>
                                    <div className="form-input">
                                        <input type="text" name="subject" id="w3lSubject" onChange={(e) => { subject = e.target.value }} placeholder="Enter subject " required />
                                    </div>
                                    <div className="form-input">
                                        <input type="email" name="email" id="w3lSender" onChange={(e) => { emailID = e.target.value }} placeholder="Enter your email *" required />
                                    </div>
                                    <div className="form-input">
                                        <input type="text" name="phone" id="w3lPhone" onChange={(e) => { phone = e.target.value }} placeholder="Enter your Phone Number *" required />
                                    </div>
                                </div>
                                <div className="form-input">
                                    <textarea name="message" id="w3lMessage" onChange={(e) => { message = e.target.value }} placeholder="Your message here" required defaultValue={""} />
                                </div>
                                <div className="text-right">
                                    <button className="btn btn-style btn-primary" id='submitbtn' onClick={() => { OnSubmitURI() }}>Submit</button>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 contacts-5-grid-main section-gap mt-lg-0 mt-5">
                            <div className="contacts-5-grid">
                                <h3 className="section-title-left mb-4"> Contact Me</h3>
                                <div className="map-content-5">
                                    <section className="tab-content">
                                        <div className="contact-type">
                                            <div className="address-grid mb-4">
                                                <h6>Address</h6>
                                                <p>{data[0].address}</p>
                                            </div>
                                            <div className="address-grid mb-4">
                                                <h6>Email Address</h6>
                                                <a href={`mailto:${data[0].email}`} className="link1">{data[0].email}</a>
                                            </div>
                                            <div className="address-grid">
                                                <h6>Phone Number</h6>
                                                <a href={`tel:${data[0].phone}`} className="link1">{data[0].phone}</a>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Contact
